// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import Lobby from './pages/lobby/lobby';
import Host from './pages/host/host';
import USER from './pages/dddUI/user';
import Waiting from './pages/waiting/waiting';
import Leaderboard from './pages/leaderboard/leaderboard';
import Category from './pages/category/category';
import Game from './pages/game/game';
import PassPlayCreate from './pages/passPlayCreate/passPlayCreate';


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const path = location.pathname.toLowerCase();
    const useCommonBg =
      !path.startsWith("/admin")
    if (useCommonBg) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]); 
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route element={<USER />}>
          <Route index element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route path="catogery" element={<Navigate to="/category" replace />} />
          <Route path="category" element={<Category />} />
          <Route path="passplay/create" element={<PassPlayCreate />} />
          <Route path="game" element={<Game />} />
          <Route path="lobby" element={<Lobby />} />
          <Route path="host" element={<Host />} />
          <Route path="leaderboard" element={<Leaderboard />} />
          <Route path="waiting" element={<Waiting />} />
          <Route path="AdminRedirect" element={<AdminRedirect />} />
        </Route>
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
